import React from "react";
import { ShieldCheck, Heart, Award, Users } from "lucide-react";
import { PageHeader, FinalCTA } from "@/components/PageHeader";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="About WeCare II"
        title="Trusted, licensed,"
        accent="person-centered"
        kicker=" in-home services."
        subtitle="WeCare II provides person-centered Supportive In-Home Services for children and adults with intellectual and developmental disabilities and individuals with mental health needs. Whether someone lives independently, with family, or with other caregivers, our team provides individualized support designed to promote safety, independence, personal choice, and a meaningful life within the community. WeCare II is licensed by the Virginia Department of Behavioral Health and Developmental Services (DBHDS) and affiliated with a local Human Rights Committee."
        data-testid="about-header"
      />

      <section className="wc-container -mt-6 md:-mt-8 pb-16 md:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: Heart, title: "Our Mission", body: "To provide compassionate, person-centered support that empowers individuals to live with greater independence, confidence, and choice in their homes and communities." },
            { icon: ShieldCheck, title: "Our Standards", body: "We are committed to dependable, high-quality support. Our team members are carefully screened, trained, and continually developed to provide respectful, person-centered services." },
            { icon: Award, title: "Our Promise", body: "To lead with consistency, respect, and communication while building trusted relationships with the individuals we support, their families, caregivers, and support coordinators." },
          ].map(({ icon: Icon, title, body }) => (
            <div key={title} className="bg-brand-navy/[0.04] backdrop-blur-sm rounded-3xl border border-brand-navy/15 p-8 hover:bg-brand-navy/[0.06] hover:border-brand-navy/25 hover:shadow-[0_20px_40px_rgba(30,42,120,0.10)]" style={{ transition: "background-color 300ms ease, border-color 300ms ease, box-shadow 300ms ease" }} data-testid={`about-pillar-${title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="w-11 h-11 rounded-xl bg-orange-50 text-brand-orange grid place-items-center"><Icon className="w-5 h-5"/></div>
              <h3 className="mt-6 font-outfit text-xl font-semibold text-brand-navy">{title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-3xl overflow-hidden bg-brand-navy text-white p-8 md:p-12 grid grid-cols-1 md:grid-cols-4 gap-6 items-center relative">
          <svg className="absolute -top-16 -right-16 w-64 h-64 pointer-events-none opacity-50" viewBox="0 0 200 200" aria-hidden="true"><circle cx="100" cy="100" r="100" fill="#f39325" fillOpacity="0.15"/></svg>
          <div className="md:col-span-3 relative">
            <div className="text-[10px] uppercase tracking-[0.28em] text-orange-300 font-bold">Compliance & Oversight</div>
            <h3 className="mt-2 font-outfit text-2xl md:text-3xl font-semibold">DBHDS-licensed. HRC-affiliated. Person-centered.</h3>
            <p className="mt-3 text-white/80 text-sm leading-relaxed">Our services are guided by DBHDS licensure standards, Human Rights Committee oversight, and the individual needs, choices, and goals of each person we support.</p>
          </div>
          <div className="flex md:justify-end relative">
            <div className="inline-flex items-center gap-3 rounded-2xl bg-white/10 px-4 py-3 border border-white/10">
              <Users className="w-5 h-5 text-brand-orange"/>
              <div><div className="text-[10px] uppercase tracking-[0.22em] text-white/60 font-bold">Est.</div><div className="font-outfit text-lg font-semibold">2019</div></div>
            </div>
          </div>
        </div>
      </section>

      <FinalCTA
        title="Ready to Get Started With WeCare II?"
        subtitle="Whether you're looking for services, making a referral, or simply have questions, our team is ready to help."
        primaryLabel="Request Services"
        primaryTo="/contact"
        secondaryLabel="Make a Referral"
        secondaryTo="/refer"
      />
    </div>
  );
}
